import { isCordovaApp } from './index'

export const requestLocationAccuracy = (): Promise<void> => (
  new Promise((resolve, reject) => {
    const isCordova = isCordovaApp

    if (!isCordova || !(window as any).cordova?.plugins?.locationAccuracy) {
      resolve()
      return
    }

    const locationAccuracy = (window as any).cordova.plugins.locationAccuracy

    locationAccuracy.request(
      () => resolve(),
      (error: any) => {
        console.error('Location accuracy request failed', error)
        // We reject here so the caller knows it failed/was denied
        reject(error)
      },
      locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY,
    )
  })
)
